import { render, staticRenderFns } from "./Medal.vue?vue&type=template&id=296ce7fe&scoped=true&"
import script from "./Medal.vue?vue&type=script&lang=js&"
export * from "./Medal.vue?vue&type=script&lang=js&"
import style0 from "./Medal.vue?vue&type=style&index=0&id=296ce7fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296ce7fe",
  null
  
)

export default component.exports